import React from 'react';
import DataTable from 'react-data-table-component';
import * as Icons from 'react-feather';
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg';
import { logAuditEvent } from '../../utils/auditLogger';

function VehiclePurchaseRegisterGrid({ details = [], onRemove, onUpdate, moduleName = 'Purchase Register' }) {
  const columns = [
    { name: <div className="titlename"><span>Vehicle</span></div>, selector: row => row.VehicleLabel || row.VehicleId, sortable: true, sortIcon: <SortArrow />, width: '325px' },
    { name: <div className="titlename"><span>Cost</span></div>, selector: row => row.VehicleCost, sortable: true, sortIcon: <SortArrow /> },
    { name: <div className="titlename"><span>Quantity</span></div>, selector: row => row.Quantity, sortable: true, sortIcon: <SortArrow /> },
    { name: <div className="titlename"><span>Chassis No</span></div>, selector: row => row.ChassisNo, sortable: true, sortIcon: <SortArrow />, cell: (row, index) => (
      <input
        className="form-control form-control-sm"
        value={row.ChassisNo || ''}
        onChange={(e) => onUpdate && onUpdate(index, 'ChassisNo', e.target.value)}
      />
    ) },
    { name: <div className="titlename"><span>Engine No</span></div>, selector: row => row.EngineNo, sortable: true, sortIcon: <SortArrow />, cell: (row, index) => (
      <input
        className="form-control form-control-sm"
        value={row.EngineNo || ''}
        onChange={(e) => onUpdate && onUpdate(index, 'EngineNo', e.target.value)}
      />
    ) }
  ];

  if (typeof onRemove === 'function') {
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row, index) => (
        <div className="edit-delete-action">
          <span
            className="confirm-text p-2"
            style={{ display: 'inline-flex', cursor: 'pointer' }}
            title={'Remove'}
            onClick={() => {
              try {
                const detailsPayload = JSON.stringify({ VehicleId: row?.VehicleId, Quantity: row?.Quantity });
                logAuditEvent(moduleName, 'Delete Button Click', detailsPayload);
              } catch (e) {}
              onRemove(index);
            }}
          >
            <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
          </span>
        </div>
      ),
      center: 'true',
      width: '120px'
    });
  }

  const totalCost = details.reduce((sum, row) => {
    const cost = Number(row.VehicleCost) || 0;
    const qty = Number(row.Quantity) || 1;
    return sum + (cost * qty);
  }, 0);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <DataTable
          className="table-responsive product-list"
          columns={columns}
          data={details}
          sortIcon={<SortArrow />}
          persistTableHead={true}
        />
        <div style={{ marginTop: '15px', textAlign: 'right', marginRight: '32px' }}>
          <strong>Total Cost: </strong>
          <span style={{ fontSize: '16px', color: '#333', fontWeight: 'bold' }}>₹ {totalCost.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
}

export default VehiclePurchaseRegisterGrid;
